import RadioCategory from './RadioCategory'

export default RadioCategory
